import { IPriceRange } from "redmond";

export const getPriceRangeText = (
  priceRange: IPriceRange,
  currencySymbol: string
) =>
  `${currencySymbol}${priceRange.min} - ${currencySymbol}${priceRange.max} per day`;
